import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const rebuildList = function (list: any) {
  let result = [];

  if (list) {
    result = list.concat();
    result.forEach((item: any) => {
      item._showChildren = true;

      if (item.children) {
        item.children = rebuildList(item.children);
      }
    });
  }

  return result;
};

const URL = {
  LIST: '/dh-datamaint/catalog/list',
  BATCH_ADD: '/dh-datamaint/catalog/batchAdd',
  DELETE: '/dh-datamaint/catalog/delete',
  DETAIL: '/dh-datamaint/catalog/getById',
  UPDATE: '/dh-datamaint/catalog/update',
  MOVE: '/dh-datamaint/catalog/move',
  ADD_SUBJECT: '/dh-datamaint/subject/add',
  SUBJECT_LIST: '/dh-datamaint/subject/listTreeByVersionId',
  CHAPTER_VIDEO_LIST: '/dh-datamaint/courseware/pageVideo',
  CHAPTER_VIDEO_TREE: '/dh-datamaint/cwSubject/listSbjCatalogTree',
  RELATED_VIDEO: '/dh-datamaint/catalog/relateVideo'
};

class CatalogModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getList(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.LIST, { params: payload.data });
      return rebuildList(res.data.data);
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.BATCH_ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async Move(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.MOVE, payload.data);
    },

    async AddSubject(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD_SUBJECT, payload.data);
    },

    async getSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SUBJECT_LIST, { params: payload.data });
    },

    async getCVTree(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.CHAPTER_VIDEO_TREE, { params: payload.data });
    },

    async getCVList(context: ActionContext<any, any>, payload: any) {
      // return await ajax.get(URL.CHAPTER_VIDEO_LIST, { params: payload.data });
      const res = await ajax.get(URL.CHAPTER_VIDEO_LIST, { params: payload.data });
      res.data.records.forEach((item: any) => {
        item.nameEn = item.nameEn || '-';
      })
      return res;
    },

    async relatedVideo(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATED_VIDEO, payload.data);
    }
  };
}

export const catalogModule = new CatalogModule();
